<template>
    <div class="sdk-dimension-container">
        <el-form :model="params.payment" ref="form" :label-width="labelWidth">
            <template v-if="!isSdkVersion5_6">
                <el-form-item label="游戏内充值：">
                    <el-radio-group
                        v-model="params.payment.charge_button_allowed"
                        @change="changeChargeButtonAllowed"
                    >
                        <el-radio :label="true">开启</el-radio>
                        <el-radio :label="false">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="隐藏所有三方渠道：">
                    <el-radio-group v-model="params.payment.apf_safe_mode">
                        <el-radio :label="true">开启</el-radio>
                        <el-radio :label="false">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item
                    label="游戏内充值渠道："
                    v-if="params.payment.charge_button_allowed"
                >
                    <el-checkbox
                        v-model="params.payment.quick_charge_google_allowed"
                        >官方渠道</el-checkbox
                    >
                    <el-checkbox
                        v-model="params.payment.quick_charge_thirdparty_allowed"
                        v-if="platform !== 'H5'"
                        @change="changeThirdpartyAllowed"
                        >第三方渠道
                    </el-checkbox>
                </el-form-item>

                <el-form-item label="渠道按国家过滤：">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content="[开启] 选项含义: 如果有当前国家渠道，则只展示当前国家渠道，若没有则展示美国渠道"
                        placement="top-start"
                    >
                        <i
                            class="el-icon-question"
                            style="margin-left: -17px;"
                        ></i>
                    </el-tooltip>
                    <el-radio-group
                        v-model="params.payment.filter_channel_with_geo_country"
                    >
                        <el-radio
                            label="no"
                            >关闭</el-radio
                        >
                        <el-radio
                            label="yes"
                            >开启</el-radio
                        >
                        <el-radio
                            label="yes-with-us"
                            >开启&一定含美国(US)</el-radio
                        >
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="提审充值：" v-if="platform !== 'H5'">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content="用于提审阶段的充值功能，开启该功能，提审人员使用测试渠道下单，无需走支付流程即可支付成功。"
                        placement="top-start"
                    >
                        <i
                            class="el-icon-question"
                            style="margin-left: -17px;"
                        ></i>
                    </el-tooltip>
                    <el-radio-group
                        v-model="params.payment.submit_recharge_allowed"
                    >
                        <el-radio
                            :label="true"
                            :disabled="submitRechargeAllowedDisabled"
                            >开启</el-radio
                        >
                        <el-radio
                            :label="false"
                            :disabled="submitRechargeAllowedDisabled"
                            >关闭</el-radio
                        >
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    label="第三方支付页面风格："
                    v-if="params.payment.quick_charge_thirdparty_allowed && 0"
                >
                    <el-radio-group
                        v-model="params.payment.charge_thirdparty_page_style"
                        @change="changeChargeThirdpartyPageStyle"
                    >
                        <el-radio :label="0">默认模版</el-radio>
                        <em
                            class="el-icon-view icon-view"
                            @click.stop="
                                handlerPreview('third_pay_page_default_style')
                            "
                        ></em>

                        <el-radio :label="1">Google指定模版</el-radio>
                        <em
                            class="el-icon-view icon-view"
                            style="left:390px"
                            @click.stop="
                                handlerPreview('third_pay_page_google_style')
                            "
                        ></em>
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    label="游戏支付方式图片："
                    v-if="
                        params.payment.quick_charge_thirdparty_allowed &&
                            params.payment.charge_thirdparty_page_style
                    "
                >
                    <div class="dialog-upload-btn-box">
                        <div class="upload-imgs">
                            <el-form-item label-width="0">
                                <upload
                                    formatlimit="png"
                                    v-model="
                                        params.payment.game_payment_method_image
                                    "
                                ></upload>
                                <div>
                                    <span
                                        @click.stop="
                                            handlerPreview(
                                                'pay_page_sample_and_size'
                                            )
                                        "
                                        class="href-rela"
                                        >示例及尺寸要求</span
                                    >
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                </el-form-item>

                <el-form-item label="游戏是否开启APF:" v-if="params.payment.charge_button_allowed">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content="如果开启了APF，即使'第三方渠道'处于关闭状态，也可以返回所有代金券套餐"
                        placement="top-start"
                    >
                        <i
                            class="el-icon-question"
                            style="margin-left: -17px;"
                        ></i>
                    </el-tooltip>
                    <el-radio-group v-model="params.payment.apf_enabled">
                        <el-radio :label="true">开启</el-radio>
                        <el-radio :label="false">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="APF 打开风格:" v-if="params.payment.apf_enabled">
                    <el-radio-group v-model="params.payment.apf_ux_style">
                        <el-radio label="bottom-drawer">游戏内底部抽屉</el-radio>
                        <el-radio label="in-app-webview">游戏内全屏</el-radio>
                        <el-radio label="external-webview">跳出的全屏弹窗</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="外跳支付页面地址：" v-if="params.payment.apf_enabled">
                    <el-input
                        size="normal"
                        v-model="params.payment.apf_external_webview_url"
                        class="sdkconfigedit-formitem-width"
                    ></el-input>
                </el-form-item>

                <el-form-item label="历史总充值达：" v-if="params.payment.apf_enabled">
                    <el-input-number
                        size="small"
                        v-model="params.payment.apf_min_history_topup"
                        class="sdkconfigedit-formitem-width"
                        :min="0"
                        :precision="0"
                        :controls="false"
                    ></el-input-number>
                    (美分)才能开启APF
                </el-form-item>
                <el-form-item label="历史总充值达：" v-if="params.payment.apf_enabled">
                    <el-input-number
                        size="small"
                        v-model="params.payment.apf_min_topup_times"
                        class="sdkconfigedit-formitem-width"
                        :min="0"
                        :precision="0"
                        :controls="false"
                    ></el-input-number>
                    (笔)订单才能开启APF
                </el-form-item>

            </template>
            <template v-else>
                <el-form-item label="OG充值：">
                    <el-radio-group
                        v-model="params.payment.charge_button_allowed"
                    >
                        <el-radio :label="true">开启</el-radio>
                        <el-radio :label="false">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="游戏内充值渠道：">
                    <el-checkbox
                        v-model="params.payment.quick_charge_google_allowed"
                        >官方渠道</el-checkbox
                    >
                    <el-checkbox
                        v-model="params.payment.quick_charge_thirdparty_allowed"
                        >第三方渠道</el-checkbox
                    >
                </el-form-item>
                <el-form-item label="SDK充值：">
                    <el-checkbox
                        v-model="params.payment.manual_charge_google_allowed"
                        >谷歌渠道展示</el-checkbox
                    >
                    <el-checkbox
                        v-model="
                            params.payment.manual_charge_thirdparty_allowed
                        "
                        >第三方渠道展示</el-checkbox
                    >
                </el-form-item>
                <el-form-item label="页面设置：">
                    <el-radio-group
                        v-model="params.payment.charge_display_type"
                    >
                        <el-radio :label="true">套餐>渠道</el-radio>
                        <el-radio :label="false">渠道>套餐</el-radio>
                    </el-radio-group>
                </el-form-item>
            </template>

            <el-form-item>
                <el-button
                    class="next-button"
                    type="primary"
                    size="small"
                    @click="handlerNext"
                    v-if="!isDetail"
                >
                    {{ isSave }}
                </el-button>
            </el-form-item>
        </el-form>
        <el-dialog
            title="预览"
            :visible.sync="styleDialogVisible"
            width="1200px"
        >
            <div slot="title">
                <h2>
                    预览
                    <span style="color:#F56C6C;"
                        >（该图片仅用来示意在界面中的显示位置，不代表真实效果。）</span
                    >
                </h2>
            </div>
            <img :src="activeUrl" alt="" width="1160" />
        </el-dialog>
    </div>
</template>
<script>
import { mapState } from "vuex";
import upload from "../../subComponents/sdkUpload";

export default {
    name: "set-login-allowed",
    components: {
        upload
    },
    data() {
        return {
            isSdkVersion5_6: true,
            submitRechargeAllowedDisabled: false,
            version: "",
            platform: "",
            activeUrl: "",
            params: {
                payment: {
                    submit_recharge_allowed: "",
                    filter_channel_with_geo_country:"",
                    charge_button_allowed: "",
                    quick_charge_google_allowed: "",
                    quick_charge_thirdparty_allowed: "",
                    manual_charge_google_allowed: "",
                    manual_charge_thirdparty_allowed: "",
                    charge_thirdparty_page_style: "",
                    game_payment_method_image: "",
                    apf_enabled: false,
                    apf_safe_mode: false,
                    apf_ux_style: 'bottom-drawer',
                    apf_min_history_topup:0,
                    apf_min_topup_times:0,
                    apf_external_webview_url: ''
                },
                step: "payment"
            },
            styleDialogVisible: false
        };
    },
    props: ["isDetail", "isCopy", "labelWidth"],
    computed: {
        ...mapState(["$helper", "$lodash"]),
        ...mapState("sdkReleasesEdit", [
            "gameVersion",
            "packageList",
            "packageStoreList",
            "sdkVersion",
            "data"
        ]),
        isSave() {
          return (this.platform === "ANDROID" && this.version < 7.07) ||  this.platform === "H5"||  this.platform === "WINDOWS"
                ? "完成"
                : "下一步";
        }
    },
    watch: {
        "data.payment"() {
            this.params.payment = this.$lodash.cloneDeep(this.data.payment);
            this.params.step = "payment";
            console.log(this.params.payment);
            if (this.params.payment.charge_button_allowed == false) {
                this.submitRechargeAllowedDisabled = true;
            }
            if (this.params.payment.quick_charge_thirdparty_allowed == false) {
                this.submitRechargeAllowedDisabled = true;
            }
        },
        "data.query"(value) {
            let version = "";
            this.sdkVersion.forEach(item => {
                if (
                    parseInt(value.sdk_version_id) ===
                    parseInt(item.sdk_version_id)
                ) {
                    version = item.version;
                }
            });
            const versionStr = version.substr(0, 2);
            console.log(versionStr);
            if (!["6.", "5."].includes(versionStr)) {
                this.isSdkVersion5_6 = false;
            } else {
                this.isSdkVersion5_6 = true;
            }
            version = this.justifyVersion(version);
            this.version = parseFloat(version);
        }
    },
    methods: {
        handlerNext() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.$emit(
                        "submit",
                        this.params,
                        this.isSave === "完成" ? "save" : ""
                    );
                }
            });
        },
        changeChargeButtonAllowed(allowed) {
            if (allowed === false) {
                this.params.payment.quick_charge_google_allowed = false;
                this.params.payment.quick_charge_thirdparty_allowed = false;
                this.changeThirdpartyAllowed(false);
            }
        },
        changeThirdpartyAllowed(allowed) {
            if (allowed === false) {
                this.params.payment.submit_recharge_allowed = false;
                this.submitRechargeAllowedDisabled = true;
            } else {
                this.submitRechargeAllowedDisabled = false;
            }
        },
        handlerPreview(key) {
            this.activeUrl = this.currentUrl(key);
            this.styleDialogVisible = true;
        },
        currentUrl(key) {
            const urls = {
                pay_page_sample_and_size: require("../../assets/pay_page_sample_and_size.png"),
                third_pay_page_default_style: require("../../assets/third_pay_page_default_style.png"),
                third_pay_page_google_style: require("../../assets/third_pay_page_google_style.png")
            };
            return urls[key];
        },
        justifyVersion(version) {
            let versionarr = version.split(".");
            let version_convert = "";
            if (versionarr[1] < 10) {
                version_convert = versionarr[0] + ".0" + versionarr[1];
            } else {
                version_convert = version;
            }
            return version_convert;
        },
        changeChargeThirdpartyPageStyle() {}
    },
    created() {
        this.platform = this.$helper.helper.getParamers("platform");
    }
};
</script>

<style lang="scss" scoped>
.sdk-dimension-container {
    .flex {
        display: flex;
    }
    .line {
        border-right: 2px dashed #d9d9d9;
        margin: 0 40px;
    }
    .tabs {
        flex: 1;
    }
    .portrait-img {
        margin: 56px auto 0;
        display: block;
    }
    .href-rela {
        color: #5cb6ff;
        cursor: pointer;
    }
    .style-diy-color {
        display: flex;
        .background-color {
            flex: 1;
            color: #fff;
            border-radius: 3px;
            margin-right: 10px;
            text-align: center;
            border: 1px solid #e6e6e6;
            padding: 5px;
            div {
                line-height: 28px;
                border-radius: 3px;
                border-radius: 3px;
            }
        }
        .icon-view {
            position: relative;
            left: 8px;
            height: 18px;
            font-size: 20px;
            padding: 8px;
            top: 1px;
            display: table;
        }
    }
    .upload-box {
        div {
            line-height: 24px;
        }
        .personal-center-font-style {
            font-size: 12px;
            color: #e6a23c;
        }
        .avatar-uploader {
            line-height: 0;
            margin-top: 20px;
        }
        .el-icon-view {
            font-size: 30px;
            color: hsla(0, 0%, 100%, 0.85);
        }
        .upload-view-landscape,
        .upload-view-portrait {
            &:hover {
                .shade,
                .content {
                    opacity: 1;
                }
            }
        }
    }
    .upload-view-landscape,
    .upload-view-portrait {
        background: #f6f6f6;
        height: 138px;
        border-radius: 4px;
        margin-top: 10px;
        overflow: hidden;
        position: relative;
    }
    .upload-view-portrait {
        background: url("../../assets/bgiphone2.png") no-repeat;
        background-size: contain;
        box-sizing: content-box;
        width: 322px;
        height: 640px;
        margin: 0 auto;
        .right-conetnt {
            width: 290px;
            height: 426px;
            margin: 56px auto 0;
            background: #f2f2f2;
            padding-top: 100px;
            position: relative;
            z-index: 1;
            .right-content-bom {
                background: #f2f2f2;
                border-radius: 5px;
                position: relative;
                height: inherit;
            }
        }
    }
    .upload-view-landscape {
        background: url("../../assets/bgiphonew.png") no-repeat;
        background-size: contain;
        box-sizing: content-box;
        .right-content-bom {
            background: #f2f2f2;
            padding-top: 10px;
            border-radius: 5px;
        }
    }
    .upload-view-landscape {
        height: 330px;
        width: 664px;
        .contents {
            position: relative;
            background: #f6f6f6;
            height: 294px;
            border-radius: 6px;
            width: 530px;
            margin: 19px auto 0;
            overflow: hidden;
        }
    }
    .right-conetnt {
        width: 60%;
        height: 100%;
        right: 0;
        position: absolute;
        z-index: 1;
        .right-conetnt-bom {
            padding: 12px 0;
            background: #f2f2f2;
        }

        .user-center,
        .taps li {
            padding: 6px 10px;
            display: flex;
            align-items: center;
            background: #fff;

            margin: 0 10px;
        }
        .user-center {
            border-radius: 5px;
            div {
                line-height: 20px;
                margin-left: 10px;
            }
        }
        .taps {
            margin-top: 10px;
            li {
                justify-content: space-between;
                div {
                    display: flex;
                    align-items: center;
                }
                span {
                    margin-left: 10px;
                    font-size: 14px;
                }
                border-bottom: 1px solid #f6f6f6;
            }
            li:first-child {
                border-radius: 5px 5px 0 0;
            }
            li:last-child {
                border: none;
                border-radius: 0 0 5px 5px;
            }
        }
    }
    .zindex-0 {
        position: absolute;
        z-index: 0;
        top: 0;
        left: 0;
    }
    .dialog-upload-btn-box {
        .upload-imgs {
            display: flex;
            text-align: center;

            .avatar-box {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
            }
        }
        .el-tabs__item {
            padding: 0 !important;
            width: 70px;
            text-align: center;
        }
        .el-tabs__header {
            width: 560px;
        }
        .upload-success,
        .upload-warning {
            width: 5px;
            height: 5px;
            border-radius: 50%;
            display: inline-block;
            margin-bottom: 7px;
        }
        .upload-success {
            background: #67c23a;
        }
        .upload-warning {
            background: #f56c6c;
        }
    }
}
</style>



// WEBPACK FOOTER //
// website/subComponents/sdk/SetPay.vue